import { Box, Typography } from "@mui/material";

function Notifications() {
  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          p: 10,
        }}
      >
        <Typography fontWeight={550} fontSize={30} textAlign="center">
          Notifications
        </Typography>
      </Box>
    </Box>
  );
}

export default Notifications;
